import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { PLAYER_LEAGUE_INFO_BASE } from '../../utils/playerLeagueInfoEmbeddedPaths';
import { useAuth } from '../../contexts/AuthContext';
import { tryNavigateFromProfileWizard } from '../../utils/incompleteProfileLeaveGuard';

const BRAND = { blue: '#043663', red: '#D52B1E', gray: '#E5E7EB', light: '#f3f4f6' };

const Wrapper = styled.div`
  width: 100%;
`;

const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${BRAND.gray};
`;

const ToolLink = styled(Link)`
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${BRAND.blue};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const ToolSep = styled.span`
  color: #cbd5e1;
  font-weight: 300;
  user-select: none;
`;

const PageLead = styled.p`
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  letter-spacing: -0.02em;

  @media (max-width: 640px) {
    font-size: 1.25rem;
  }
`;

export default function PlayerLeagueInfoLayout() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();
  const onHub =
    location.pathname === PLAYER_LEAGUE_INFO_BASE || location.pathname === `${PLAYER_LEAGUE_INFO_BASE}/`;

  const guarded = (e, to) => {
    if (!tryNavigateFromProfileWizard(user, location.pathname, to)) {
      e.preventDefault();
    }
  };

  return (
    <Wrapper>
      <Toolbar>
        <ToolLink to="/player/settings" onClick={(e) => guarded(e, '/player/settings')}>
          ← {t('phase2.playerLeagueInfo.backSettings')}
        </ToolLink>
        {!onHub && (
          <>
            <ToolSep aria-hidden>|</ToolSep>
            <ToolLink
              to={PLAYER_LEAGUE_INFO_BASE}
              onClick={(e) => guarded(e, PLAYER_LEAGUE_INFO_BASE)}
            >
              {t('phase2.playerLeagueInfo.allTopics')}
            </ToolLink>
          </>
        )}
      </Toolbar>
      {onHub ? (
        <>
          <PageLead>{t('phase2.playerLeagueInfo.sectionTitle')}</PageLead>
          <Outlet />
        </>
      ) : (
        <Outlet />
      )}
    </Wrapper>
  );
}
